import React from 'react'
import { Segment, Container, Image } from 'semantic-ui-react'

const Footer: React.FC = () => (
  <Segment inverted vertical size='tiny' style={{ padding: '1em 0'}}>
    <Container textAlign='center' style={{ width: '100%' }}>     
     
    </Container>
  </Segment>
)

export default Footer
